export class UserService {
    constructor($http, $rootScope, PhotoService) {
      this.http = $http;
      this.rootScope = $rootScope;
      this.PhotoService = PhotoService;
    }

  getUniqNum() {
    return (String(Math.random()).toString()).replace("0.", "");
  }

  createContact(user) {
    function calculate_age(birth_month, birth_day, birth_year) {
      var today_date = new Date();
      var today_year = today_date.getFullYear();
      var today_month = today_date.getMonth();
      var today_day = today_date.getDate();
      var age = today_year - birth_year;

      if (today_month < (birth_month - 1)) {
        age--;
      }
      if (((birth_month - 1) == today_month) && (today_day < birth_day)) {
        age--;
      }
      return age;
    }

    user.age = calculate_age(user.birthday.getMonth(), user.birthday.getDay(), user.birthday.getFullYear());

    return this.http.post('/api/users/createPermanentContact/?' + this.getUniqNum(), user);
  }

    getUserChart(options) {
      return this.http.post('/api/admin/user/user-chart', options);
    }

    getUserChartExport(options) {
      return this.http.post('/api/admin/user/user-chart/export', options);
    }

    getPermanentContacts() {
      return this.http.get('/api/users/permanentContacts?' + this.getUniqNum());
    }

    removeUser(user) {
      return this.http.delete('/api/users/' + user._id+'?'+ + this.getUniqNum());
    }

    recoverPassword(params) {
      return this.http.post("/api/user/recover", params);
    }

    getUsersForContactMessage(filter) {
      return this.http.get('/api/users/usersForPermanentContact/'+filter+'?' + this.getUniqNum());
    }

    getUserProfile(id) {
        return this.http.get('/api/user/' + id + '?' + this.getUniqNum());
    }

    getUserProfilesByName(request){
        return this.http.post('/api/filters/users?' + this.getUniqNum(), request);
    }

    getUserProfileByName(name) {
      return this.http.get('/api/user-name/' + name);
    }

    getFilteredUsers(filter, page, limit) {
      return this.http.get(`/api/filters/users/${filter}/${page}/${limit}?${this.getUniqNum()}`);
    }

    getNewUsers(filter, page, limit) {
      return this.http.get(`/api/users/new-users/${filter}/${page}/${limit}?${this.getUniqNum()}`);
    }

    getCelebrateUsers(filter, page, limit) {
      return this.http.get(`/api/users/celebrate/${filter}/${page}/${limit}?${this.getUniqNum()}`);
    }

    getOnlineUsers(filter, page, limit) {
      return this.http.get(`/api/users/online/${filter}/${page}/${limit}?${this.getUniqNum()}`);
    }

    getDailyUsers(user, page, limit) {
      return this.http.get(`/api/daily/users/${user}/${page}/${limit}?${this.getUniqNum()}`);
    }

    updateUser(user) {
      return this.http.post("/api/user?" + this.getUniqNum(), user);
    }

    changePassword(params) {
      return this.http.put("/api/user/change/password", params);
    }

    changeNotifications(params) {
      return this.http.put("/api/user/change/notifications", params);
    }

    changeCounters(params) {
      return this.http.put('/api/user/change/counters', params);
    }

    signIn(user) {
      return this.http.post('/api/signin', user);
    }

    getUsers(userIds) {
      return this.http.post("/api/user/getFewUsers", {users: userIds});
    }

    createRecommendation(data) {
      return this.http.post(`/api/user/createRecommendation/?${this.getUniqNum()}`, data);
    }

    updateRecommendations(user, recommendations) {
      return this.http.put(`/api/user/updateRecommendations/${user}?${this.getUniqNum()}`, recommendations);
    }

    approveProfileText(userId, informationPersonal) {
      return this.http.put(`/api/user/approveprofiletext/${userId}`, informationPersonal);
    }

    rejectProfileText(userId, params) {
      return this.http.put(`/api/user/rejectprofiletext/${userId}`, params);
    }

    declineProfileText(userId) {
      return this.http.get(`/api/user/declineprofiletext/${userId}`)
    }

    getCurrentUser(){
      return this.http.get("/api/user/get/current/?" + this.getUniqNum());
    }

    getUserReports(filtr, page, limit) {
      return this.http.get("/api/user/report/" + filtr + "/" + page + "/" + limit)
    }

    sendReport(params) {
      return this.http.post('/api/user/report', params)
    }

    deleteUserReports(key) {
      return this.http.delete('/api/user/report/'+key);
    }

    /**
     * Return path to avatar considering, whether current avatar is approved
     * @param user Obj
     * @returns {string|UserSchema.photoprofile.url| Or default avatar with pending watermark}
     */
    getAvatar(user, isOwnPage, size = '') {
        if (!user) {
          return;
        }
        else if(user.photoprofile && user.photoprofile.approved && user.photoprofile.url) {
          return `/dating-profile-photos/${user.photoprofile.url}${size}.jpg`;
        }
        else if (user.photoprofile && user.photoprofile.approved === false && user.photoprofile.newUrl && isOwnPage) {
          return `/dating-profile-photos/${user.photoprofile.newUrl}${size}.jpg`;
        }
        else if (user.photoprofile && user.photoprofile.approved === false && user.photoprofile.url && !isOwnPage) {
          return `/dating-profile-photos/${user.photoprofile.url}${size}.jpg`;
        }
        else {
          return (user.gender == 1) ? "images/user/defaultMan.jpg" : "images/user/defaultWoman.jpg";
        }
    }

    getProfileTextUnapproved(page, limit) {
        return this.http.get("/api/users/profileTextUnapproved/" + page + "/" + limit + "?" + this.getUniqNum());
    }

    updateUser(user) {
        return this.http.post("/api/user?" + this.getUniqNum(), user);
    }

    addToIgnore(id) {
      let params = {
        userId: this.rootScope.currentUserProfile._id,
        ignorableId: id
      };

        return this.http.post('/api/user/addtoignore/?' + this.getUniqNum(), params);
    }

    deactivateProfile(userId, password) {
        let params = {
          id: userId,
          pass: password
        };
        return this.http.post('/api/user/deactivate/?' + this.getUniqNum(), params);
    }

    activateProfile(userId, password) {
      let params = {
        id: userId,
        pass: password
      };

      return this.http.post('/api/user/activate/?' + this.getUniqNum(), params);
    }

}
